import React from 'react';
import { Handle, Position } from '@xyflow/react';

const iconStyle = { width: 14, height: 14, flexShrink: 0, color: 'var(--text-tertiary)' };

const ModelIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={iconStyle}>
    <path d="M12 2a4 4 0 0 0-4 4v2a4 4 0 0 0 8 0V6a4 4 0 0 0-4-4Z" />
    <path d="M4 12a8 8 0 0 1 16 0" />
    <path d="M4 16v2a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-2" />
  </svg>
);

const MemoryIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={iconStyle}>
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
  </svg>
);

const MEMORY_LABELS = {
  simple: 'Simple memory',
  postgres: 'PostgreSQL memory',
  mongodb: 'MongoDB memory',
};

export default function AgentNode({ data, selected }) {
  const config = data?.config ?? {};
  const model = config.model?.trim() || null;
  const memoryKey = config.memory?.trim() || null;
  const memoryLabel = memoryKey ? (MEMORY_LABELS[memoryKey] ?? memoryKey) : null;

  return (
    <div
      className={data?.__animateAppear ? 'workflow-node-appear' : undefined}
      style={{
        padding: '14px 18px',
        background: 'var(--card-bg)',
        border: selected ? '2px solid #6366f1' : '1px solid var(--border-color)',
        borderRadius: '8px',
        minWidth: 180,
        boxShadow: selected ? '0 0 0 2px rgba(99, 102, 241, 0.3)' : '0 2px 8px rgba(0,0,0,0.2)',
      }}
    >
      <Handle type="target" position={Position.Left} style={{ background: '#6366f1', width: 14, height: 14, borderRadius: '50%' }} />
      <div style={{ fontWeight: 600, marginBottom: 8, fontSize: '1rem', color: 'var(--text-primary)' }}>Agent</div>
      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginBottom: 8 }}>{data?.label ?? 'Agent'}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: '0.75rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: 'var(--text-tertiary)' }}>
          <ModelIcon />
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{model || '—'}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: 'var(--text-tertiary)' }}>
          <MemoryIcon />
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{memoryLabel || 'No memory'}</span>
        </div>
      </div>
      <Handle type="source" position={Position.Right} style={{ background: '#6366f1', width: 14, height: 14, borderRadius: '50%' }} />
    </div>
  );
}
